var _path, _circle, _circle2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbWhiteStyle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 35,
    viewBox: "0 0 54 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9688 0H15.9844H13.9922H13.0078L0 34.125H4.61719L7.86068 25.1953H12.3203V21.4922H9.20574L14.9892 5.56958L20.2782 20.1006L20.2826 20.099L22.1225 25.1953H22.1326L25.3828 34.125H30.0234L16.9688 0Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.8203,
    cy: 23.625,
    r: 3.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 8.5,
    r: 3.5,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5234 18.1641H35.7188H42.1641C43.6953 18.1641 44.9453 18.4141 45.9141 18.9141C46.8828 19.4141 47.5938 20.125 48.0469 21.0469C48.5 21.9688 48.7266 23.0625 48.7266 24.3281C48.7266 25.5781 48.4609 26.6641 47.9297 27.5859C47.3984 28.4922 46.625 29.1953 45.6094 29.6953C44.6094 30.1953 43.3906 30.4453 41.9531 30.4453H34.5234V18.1641ZM33.4689 14.54H34.5234H35.0391V14.5312H35.7656H41.3203C42.6172 14.5312 43.75 14.3125 44.7188 13.875C45.6875 13.4375 46.4375 12.8125 46.9688 12C47.5156 11.1719 47.7891 10.1875 47.7891 9.04688C47.7891 7.79688 47.5469 6.78125 47.0625 6C46.5938 5.20312 45.8672 4.625 44.8828 4.26562C43.9141 3.89062 42.6797 3.70312 41.1797 3.70312H34.5234V6.54H30V0H41.1797C42.9297 0 44.4922 0.179688 45.8672 0.539062C47.2422 0.882812 48.4062 1.42969 49.3594 2.17969C50.3281 2.91406 51.0625 3.85156 51.5625 4.99219C52.0625 6.13281 52.3125 7.5 52.3125 9.09375C52.3125 10.5 51.9531 11.7734 51.2344 12.9141C50.5156 14.0391 49.5156 14.9609 48.2344 15.6797C47.9353 15.8495 47.624 16.005 47.3005 16.146C48.2001 16.3878 49.0036 16.7558 49.7109 17.25C50.8516 18.0312 51.7188 19.0312 52.3125 20.25C52.9219 21.4688 53.2266 22.8125 53.2266 24.2812C53.2266 26.4062 52.7578 28.2031 51.8203 29.6719C50.8984 31.125 49.5938 32.2344 47.9062 33C46.2188 33.75 44.2344 34.125 41.9531 34.125H34.5234H31.7344H30V14.54H33.4689Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbWhiteStyle);
export default __webpack_public_path__ + "static/media/ab_white_style.842b0c2073916fb588375590ed70ddf8.svg";
export { ForwardRef as ReactComponent };